import tailwindConfig from '../../../../tailwind.config';

type Props = {
  size: number;
  color?: string;
};

const Map = ({ size, color = tailwindConfig.theme.colors.gray[600] }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.7121 11.968C21.6665 10.4809 21.0457 9.06939 19.9802 8.03082C18.9148 6.99225 17.4879 6.40762 16.0001 6.40003C14.5076 6.3829 13.069 6.95727 11.9987 7.9976C10.9284 9.03793 10.3134 10.4596 10.2881 11.952C10.4089 13.5026 10.9149 14.9985 11.7601 16.304C12.9772 17.9858 14.3369 19.5596 15.8241 21.008C15.8451 21.0319 15.871 21.051 15.8999 21.064C15.9289 21.0771 15.9603 21.0839 15.9921 21.0839C16.0239 21.0839 16.0553 21.0771 16.0842 21.064C16.1132 21.051 16.1391 21.0319 16.1601 21.008C17.6069 19.572 18.9339 18.0201 20.1281 16.368C20.9813 15.0396 21.5228 13.5354 21.7121 11.968Z"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M15.9999 13.904C16.963 13.904 17.7439 13.1232 17.7439 12.16C17.7439 11.1968 16.963 10.416 15.9999 10.416C15.0367 10.416 14.2559 11.1968 14.2559 12.16C14.2559 13.1232 15.0367 13.904 15.9999 13.904Z"
        fill={color}
      />
      <path
        d="M20.4802 16H25.6002L28.8002 25.6H3.2002L6.4002 16H10.6082"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Map;
